const IFRAME_READY = 'IFRAME_READY';
const OPEN_PICKER = 'OPEN_PICKER';
const SELECT_FILE = 'SELECT_FILE';
const INSERT_MEDIA = 'INSERT_MEDIA';
const CLOSE_PANEL = 'CLOSE_PANEL';
const CLICK_DETAILS = 'CLICK_DETAILS';
const MessageTypes = {
  IFRAME_READY,
  OPEN_PICKER,
  SELECT_FILE,
  INSERT_MEDIA,
  CLOSE_PANEL,
  CLICK_DETAILS
};
export default MessageTypes;